<template>
  <div>
    <b-list-group>
      <b-list-group-item
        v-for="record in records"
        :key="record.id"
        class="flex-column align-items-start mb-2 main-column"
      >
        <div class="d-flex w-100 justify-content-between align-items-center reference">
          <span class="cursor-pointer font-weight-bold">
            ID: {{ record.id }}, {{ record.name_from_file }}
            ({{ record.unit_percent }}<template v-if="record.property && record.property.name">, {{ record.property.name }}</template>)
          </span>
          <div class="d-flex align-items-center">
            <i class="bx bx-edit cursor-pointer mr-2" @click.stop="showEdit(record)"></i>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
    <Bdr2026OneCSidebar
      :isOpen.sync="isOpen"
      :editedItem.sync="editedItem"
      @updateItem="updateItem"
    />
  </div>
</template>

<script>
import Bdr2026OneCSidebar from '@/components/bdrPage/Bdr2026OneCSidebar.vue';

const initialItem = () => ({
  name_from_file: '',
  bdr2026_dictionary_id: null,
  unit_percent: '',
  always_pass: 0,
  property: {}
});

export default {
  name: 'Bdr2026OneCProperties',
  components: { Bdr2026OneCSidebar },
  props: {
    records: { type: Array, required: true }
  },
  data() {
    return {
      editedItem: { ...initialItem() },
      isOpen: false
    };
  },
  methods: {
    showEdit(record) {
      this.editedItem = {
        id: record.id,
        name_from_file: record.name_from_file,
        bdr2026_dictionary_id: record.bdr2026_dictionary_id,
        unit_percent: record.unit_percent || '',
        always_pass: record.always_pass || 0,
        property: record.property || {},
        splits: record.splits && record.splits.length ? record.splits.map(s => ({
          unit: s.unit,
          perc: s.perc != null ? Number(s.perc) : 100,
          bdr2026_dictionary_id: s.bdr2026_dictionary_id != null ? s.bdr2026_dictionary_id : null
        })) : []
      };
      this.isOpen = true;
    },
    updateItem() {
      this.$emit('update-item');
    }
  }
};
</script>
